import { observable, action, runInAction } from 'mobx';
import { MDialog } from '@weapp/ui';
import { bindParamsType } from './type';
import * as LoginAPI from "../../../api/login";
import { setCookie, inApp, mainHost, setTokenStorage, isEcologyEnv } from '../../../utils';
import { getLabel, WeappSDK, weappSDK } from '@weapp/utils';
import { publicUrl } from "../../../constants";

const { toast, prompt } = MDialog;
export class mThirdBindStore {
    @action
    ecToEteams = () => {//ec无团队下跳eteams
        let confirm: any;
        prompt({
            title: getLabel('93425', '温馨提示'),
            prompt: false,
            message: getLabel('227055', '当前账号非e10私有化账号，请前往云端登录'),
            mask: true,
            maskClosable: true,
            onClose: () => {

            },
            onOk: () => {
                window.location.href = 'https://weapp.eteams.cn'
                confirm?.onClose?.();
            },
            okText: getLabel('93406', '确定'),
            cancelText: getLabel('93427', '取消'),
        })
    }
    @action
    bindCount = (params: bindParamsType) => {

        const oriParams = JSON.parse(window.sessionStorage.getItem('thirdParams') as any);
        const bindParams = {
            account: params.account,
            password: params.password,
            openId: oriParams.openId,
            thirdType: oriParams.thirdType,
            secondImei: oriParams.secondImei,
            imei: oriParams.imei,
            version: oriParams.version,
            nickName: oriParams.nickname,
        }
        LoginAPI.thirdBindAccount(bindParams).then((result: any) => {
            let result1 = result.result;
            if (result1 && result1.ETEAMSID != null && result1.ETEAMSID != "" && result.returnCode == 1) {
                let host = window.location.hostname;
                let domain = host.substr(host.indexOf(".") + 1);
                // weappSDK.invoke("clearWebCaches", {
                //     success: (res:any)=> {}
                // });

                setCookie('ETEAMSID', result1.ETEAMSID);
                setCookie('ETEAMSID', result1.ETEAMSID, domain);
                if (result1.employeeid) {
                    // if (inApp()) {
                    weappSDK.register('login', (params: any) => {
                        weappSDK.customSDK.invoke('login', params)
                    })
                    weappSDK.exec('login', {
                        loginkey: result1.ETEAMSID,
                        tenantid: result1.tenantkey,
                        userid: result1.employeeid,
                        username: result1.username,
                        password: "",
                        langid: result1.langType,
                        cid: result1.cid,
                        into: 1,
                    }).then((res: any) => {
                        console.log(res)
                    })
                    // } else {
                    //     window.location.href = mainHost();
                    // }
                } else {
                    if (result1.userIdToken) {
                        setTokenStorage(result1.userIdToken);
                    }
                    window.sessionStorage.setItem('passport_sign_account', result?.account || '');
                    if (isEcologyEnv()) {
                        this.ecToEteams(); return;
                    }
                    window.location.href = `${publicUrl}/passport/teams`;
                }
            } else {
                if (result.message) {
                    toast({
                        content: result.message,
                        mask: false,
                        delay: 2000
                    });
                } else if (result.actionMsg) {
                    toast({
                        content: result.actionMsg.message,
                        mask: false,
                        delay: 2000
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    @action
    skip = () => {
        const oriParams = JSON.parse(window.sessionStorage.getItem('thirdParams') as any);
        const bindParams = {
            openId: oriParams.openId,
            thirdType: oriParams.thirdType,
            secondImei: oriParams.secondImei,
            imei: oriParams.imei,
            nickName: oriParams.nickname,
            version: oriParams.version,
        }
        LoginAPI.thirdSkipBindAccount(bindParams).then((result: any) => {
            if (result.username) {
                window.sessionStorage.setItem('passport_sign_account', result.username || '');
            }
            if (result.userIdToken) {
                setTokenStorage(result.userIdToken, "thirdLogin");
                window.sessionStorage.setItem('thirdSkipBindAccount_params', JSON.stringify(bindParams));
                if (isEcologyEnv()) {
                    this.ecToEteams(); return;
                }
                window.location.href = `${publicUrl}/passport/teams`;
            }

            if (result.message) {
                toast({
                    content: result.message,
                    mask: false,
                    delay: 2000
                });
            } else if (result.actionMsg) {
                toast({
                    content: result.actionMsg.message,
                    mask: false,
                    delay: 2000
                });
            }
        });
    }
}

const instance = new mThirdBindStore();
export type mThirdBindStoreType = Pick<mThirdBindStore, keyof mThirdBindStore>;
export default instance;
